<template>
  <div class="Product" @click.stop="show">
    <div class="Product-header">
      <h2>请选择对方商品<span>（最多3件）</span></h2>
      <div class="close-icon" @click="closeToast">
        <Icon name="cross" />
      </div>
    </div>
    <Stance
      type="general"
      :show-info="false"
      descText="对方没有在架商品欧~"
      v-if="productList.length === 0 && !loading"
    />
      <div class="Product-wrap" v-else>
        <product-list
          :list="productList"
          @select="select"
          :curSelect="currentSelected"
          :defaultSelect="defaultSelect"
          @to-bottom="fetchMore"
        >
        </product-list>
    </div>
    <z-button size="large" :disabled="currentSelected.length === 0" @click="commit" type="primary">{{btnText}}</z-button>
  </div>
</template>

<script>
import { Stance, Icon, Button } from '@zz-common/zz-ui'
import { getinfolist } from '@api/resourceApi'
import ProductList from './ProductList'
import { toast } from '../../../native'

// const DEFAULT_PAGE_SIZE = 10
const MAX_CHOICE_COUNT = 3 //最大多选数
export default {
  name: 'ReportProduct',
  props: ['beReportedUid', 'defaultSelect'],
  data() {
    return {
      count: 0,
      isLoading: false,
      currentSelected: [],
      PageNo: 1,
      productList: [],
      fetchLoading: false,
      isPageEnd: false,
      firstDisaplay: true,
      loading: true
    }
  },
  computed: {
    btnText() {
      if (this.currentSelected.length > 0) return '下一步'
      return '请选择要举报的商品'
    }
  },
  mounted() {
    //if (this.defaultSelect) this.currentSelected.push(this.defaultSelect);
    this.init()
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.count++
      }, 500)
    },
    init() {
      console.log('.....proli', this.productList)
      this.getProductInfo()
    },
    show() {
      console.log('点击内部遮罩层不关闭')
    },
    select(item) {
      if (this.currentSelected.indexOf(item) > -1) {
        this.currentSelected.splice(this.currentSelected.indexOf(item), 1)
        return ''
      }
      if (
        this.currentSelected.length === MAX_CHOICE_COUNT &&
          this.currentSelected.indexOf(item) === -1
      ) {
        return toast({
          msg: `您最多可以举报${MAX_CHOICE_COUNT}个商品`,
          style: '3'
        })
      }
      this.currentSelected.push(item)
    },
    commit() {
      this.$emit('selected', this.currentSelected)
    },
    fetchMore() {
      if (this.fetchLoading || this.isPageEnd) return
      this.getProductInfo().then((data) => {
        if (data && data.length <= 0) {
          this.isPageEnd = true
        }
      })
    },
    closeToast() {
      this.$emit('close')
    },
    // 获取商品接口
    getProductInfo() {
      this.fetchLoading = true
      return getinfolist({
        infoId: this.defaultSelect,
        toUid: this.beReportedUid,
        pageNo: this.PageNo++
      })
        .then((res) => {
          this.fetchLoading = false
          this.productList = this.productList.concat(res)
          res.forEach((item) => {
            if (
              item.infoId === this.defaultSelect &&
                this.currentSelected.indexOf(this.defaultSelect) === -1
            ) {
              this.currentSelected.push(this.defaultSelect)
            }
          })
          this.loading = false
          return res
        })
        .catch((err) => {
          this.fetchLoading = false
          this.loading = false
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    }
  },
  components: {
    ProductList,
    Icon,
    Stance,
    zButton: Button
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
